import React from 'react';
import PlayerAvailabilityPage from '../../../pages/PlayerAvailabilityPage';

export default function HelpAvailabilityPanel() {
  return <PlayerAvailabilityPage embedded />;
}
